<template>
  <div>
    <v-app-bar
      clipped-left
      outlined
      app
      flat
      color="white"
      height="72"
      class="px-4"
    >
      <v-row align="center">
        <v-col cols="5">
          <div class="py-3">
            <router-link to="/" class="d-inline-block logo">
              <img src="@/assets/images/logo.svg" />
            </router-link>
          </div>
        </v-col>

        <v-col cols="7">
          <div class="d-flex align-center justify-end">
            <v-menu
              offset-y
              content-class="elevation-0 mt-1 rounded"
              v-if="loggedInUser"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="gray"
                  text
                  rounded
                  v-bind="attrs"
                  v-on="on"
                  class="pa-0"
                >
                  <div class="d-flex align-center">
                    <v-avatar color="primary" size="32">
                      <span class="body-1 white--text">{{
                        loggedInUserAvatar
                      }}</span>
                    </v-avatar>
                    <span
                      class="subtitle-2 text-none pl-2 pr-3 gray--text text--darken-3"
                      >{{ loggedInUserName }}</span
                    >
                  </div>
                </v-btn>
              </template>

              <v-list outlined class="rounded" dense>
                <v-list-item @click="changePasswordModal = true">
                  <v-list-item-title>
                    <span class="body-2">{{
                      $t("header.change-password")
                    }}</span>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item @click="logOut">
                  <v-list-item-title>
                    <span class="body-2">{{ $t("header.log-out") }}</span>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </v-col>
      </v-row>

      <v-toolbar-title></v-toolbar-title>
    </v-app-bar>

    <ChangePassword
      v-if="changePasswordModal"
      :modal="changePasswordModal"
      @closeModal="changePasswordModal = false"
      @submitModal="changePasswordModal = false"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import authenticationMixins from "@/mixins/authenticationMixins";
import ChangePassword from "@/views/change-password/index.vue";

export default {
  mixins: [authenticationMixins],
  data: () => ({
    drawer: null,
    changePasswordModal: false,
  }),
  components: { ChangePassword },
  computed: {
    ...mapGetters({
      loggedInUser: "Auth/getLoggedInUser",
    }),
    loggedInUserName() {
      return `${this.loggedInUser?.username}`;
    },
    loggedInUserAvatar() {
      return this.loggedInUser?.username.charAt(0).toUpperCase();
    },
  },
  methods: {
    async logOut() {
      await this.globalLogOut(() => {
        this.$router.push("/login");
      });
    },
  },
};
</script>

<style lang="scss">
.theme--light.v-app-bar.v-toolbar.v-sheet {
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.25) !important;
}
</style>
